export default "__VITE_ASSET__OhT1aWkU__"